export const ALL_CLASSES_OF_BUSINESS = [
  'Accident and health',
  'Agriculture and forestry',
  'Airline liability',
  'Allied lines',
  'Auto liability',
  'Auto or Motor',
  'Auto physical damage and liability',
  'Auto physical damage',
  'Aviation all classes',
  'Aviation cargo',
  'Aviation Hull & Liability',
  'Aviation hull',
  'Aviation liability',
  'Aviation manufacturers',
  'Aviation personal accident',
  'Aviation products',
  'Aviation Spares',
  'Aviation',
  'Baggage',
  'Boiler and machinery',
  'Burglary',
  'Business Interruption (Business Income)',
  'Casualty or liability',
  'Commercial loss of profits',
  'Commercial multiple peril',
  'Commercial Reinsurance to Close',
  'Commercial single peril',
  'Consequential Loss',
  'Construction Liability',
  'Construction',
  'Contingency liability',
  'Contingency/pecuniary loss',
  'Contract frustration',
  'Contractors risks',
  'Credit accident and health',
  'Credit and Bonding',
  'Cyber',
  'Difference in conditions',
  'E-commerce',
  'Earthquake',
  'Electronics',
  'Employers liability',
  'Energy Construction',
  'Energy Liability',
  'Energy operators',
  'Energy',
  'Engineering',
  'Environmental/pollution liability',
  'Events and Media',
  'Excess liability',
  'Farmowners',
  'Fidelity',
  'Financial guarantee',
  'Financial Services',
  'Financial',
  'Fire',
  'Flood',
  'Forgery',
  'General aviation liability',
  'General aviation',
  'General liability',
  'Glass',
  'Group accident and health',
  'Guarantee - loss of profits',
  'Hail',
  'Health',
  'Homeowners',
  'Hospitals / Healthcare Institutions',
  'Inland marine',
  'Intellectual Property',
  'Life',
  'Liquidated damages',
  'Livestock and bloodstock',
  'Marine - general',
  'Marine - Liability',
  'Marine cargo',
  'Marine hull',
  'Marine',
  'Medical malpractice',
  'Motor',
  'Multilines',
  'Music instruments',
  'Natural catastrophes',
  'Nuclear',
  'Ocean marine',
  'Other liability',
  'Pecuniary loss',
  'Personal - Financial',
  'Personal accident and health',
  'Personal accident',
  'Personal liability',
  'Political risks',
  'Product liability',
  'Professional Liability',
  'Property',
  'Railways',
  'Robbery',
  'Sickness',
  'Space and Satellites',
  'Specie',
  'Stop loss',
  'Storage liability',
  'Surety bonding',
  'Umbrella liability',
  'Uninsured Loss',
  'Various',
  'Water damage',
  'Whole account',
  'Wind storm',
  'Wood infestation',
  "Workers' compensation",
] as const;
